// removed by extract-text-webpack-plugin
module.exports = {"subHeader":"subHeader__1WTvT","subHeaderFlexed":"subHeaderFlexed__2h0D9"};


//////////////////
// WEBPACK FOOTER
// ./components/ui/alert/style.scss
// module id = CWTV
// module chunks = 27